import React, { useRef, useState } from 'react'
import _ from 'lodash'
import { DirectoryInput } from '@vzmi/shp_shared_compo'
import { excelToJSON } from '@vzmi/component_ec_nodejs_util/dist/lib/excelUtil'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import useS3Upload from '../hooks/useS3Upload'
import {
  getUpdateImageExcelData,
  getLocalImagesFromExcelData,
  checkExcelData
} from './Listing/QueryPage/exportBatchUpdateImageHelper'

const validations = async (file) => {
  const fileName = file.name
  const isSizeCorrect = await new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = event => {
      const img = new Image()
      img.onload = () => resolve(img.height === 1000 && img.width === 1000)
      img.src = event.target.result
    }
    reader.readAsDataURL(file)
  })
  if (!isSizeCorrect) {
    return { fileName, message: '圖片尺寸不符合' }
  }

  return {}
}

const Test = props => {
  const {
    getWssId,
    getCredentials,
    transformS3Object,
    fetchWssid,
    fetchListings
  } = props
  const actions = {
    getWssId,
    getCredentials,
    transformS3Object
  }
  const s3FileRef = useRef()
  const excelRef = useRef()
  const {
    isLoading,
    error,
    trigger,
    result: uploadImageResult
  } = useS3Upload(actions, validations)
  // } = useS3Upload(actions)

  const onClick = async () => {
    const files = s3FileRef.current.getFileListByNames(['aaa.jpg', 'bbb.jpg', 'cookie.png', '35MB.jpg'])
    // const files = s3FileRef.current.getTotalFileList()
    const result = await trigger(files || [])
    console.log(result)
  }

  const [checkedExcelData, setCheckedExcelData] = useState({})
  const onCheckExcel = async () => {
    // get excel data
    const json = await excelToJSON({ target: excelRef.current })
    const excelData = getUpdateImageExcelData(json)
    // get listing Ids from excel data
    const id = _.flow(
      () => _.map(excelData, 'id'),
      _.compact,
      ids => _.join(ids, COMMA)
    )()
    // get listings
    const [listingError, res] = await safeAwait(
      fetchWssid()
        .then(resp => _.get(resp, 'payload.wssid'))
        .then(wssid => fetchListings({ id, wssid, fields: '' }))
    )
    if (listingError) {
      alert(listingError.message)
      return
    }

    const { listings } = _.get(res, 'payload', {})
    // check excel data
    const result = checkExcelData(excelData, listings)
    setCheckedExcelData(result)
    console.log(result, excelData)

    // upload excel data local image to s3
    const localImages = getLocalImagesFromExcelData(excelData)
    const files = s3FileRef.current.getFileListByNames(localImages)
    const { error: s3Error, result: s3Result } = await trigger(files || [])
    if (!_.isEmpty(s3Error)) {
      alert(s3Error)
      return
    }
    console.log(s3Result)

    // merge yimg to excel data here
  }

  return (
    <div>
      <h2>useS3Upload</h2>
      <DirectoryInput ref={s3FileRef} />
      <button onClick={onClick}>upload</button>
      <h3>{`${isLoading ? 'loading' : 'loaded'}`}</h3>
      <pre>
        error:
        {JSON.stringify(error, null, 2)}
      </pre>
      <pre>
        {JSON.stringify(uploadImageResult, null, 2)}
      </pre>
      <hr />
      <h2>checkExcelData</h2>
      <input
        type='file'
        ref={excelRef}
      />
      <button onClick={onCheckExcel}>
        check excel
      </button>
      <pre>
        {JSON.stringify(checkedExcelData, null, 2)}
      </pre>
    </div>
  )
}

export default Test
